import { VDivider } from 'vuetify/lib/components/VDivider';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VDivider,{staticClass:"my-4"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }